// covered-by: frontends/carrie/src/components/ask-puntt-review/__tests__/AskPunttReviewCommentBadge.test.tsx
type AskPunttReviewCommentBadgeProps = {
  number: number;
  /** `soft` for a minor or check finding, matching its pin on the artwork. */
  tone?: "strong" | "soft";
  className?: string;
  "data-testid"?: string;
};

export function AskPunttReviewCommentBadge({
  number,
  tone = "strong",
  className = "",
  "data-testid": testId,
}: AskPunttReviewCommentBadgeProps) {
  const colors =
    tone === "soft"
      ? "border border-puntt-accent-7 bg-puntt-accent-4 text-puntt-accent-11"
      : "bg-puntt-accent-9 text-base-white";
  return (
    <span
      className={`flex size-7 shrink-0 items-center justify-center rounded-full text-[12px] font-semibold ${colors} ${className}`}
      data-testid={testId}
      data-tone={tone}
      aria-hidden="true"
    >
      {number}
    </span>
  );
}
